import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../config/firebase";
import { getCache, setCache } from "../../services/cacheService";

const TruongNganhDashboard = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const today = new Date();
  const maNganh = user?.maNganh || "";

  const [stats, setStats] = useState({ tongHS: 0, tongLop: 0, tongGV: 0, tyLeCC: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!maNganh) { setLoading(false); return; }
    const fetchData = async () => {
      const cached = getCache(`truongnganh_${maNganh}`);
      if (cached) { setStats(cached); setLoading(false); return; }
      setLoading(true);
      try {
        const lopSnap = await getDocs(query(collection(db, "lopHoc"), where("nganhId", "==", maNganh)));
        const lopList = lopSnap.docs.map(d => d.data());
        const hsSnap = await getDocs(collection(db, "hocSinh"));
        const hsTrongNganh = hsSnap.docs.filter(d => lopList.some(l => l.id === d.data().lopHienTaiId));
        const userSnap = await getDocs(query(collection(db, "nguoiDung"), where("maNganh", "==", maNganh)));
        const newStats = { tongHS: hsTrongNganh.length, tongLop: lopList.length, tongGV: userSnap.size, tyLeCC: 85 };
        setStats(newStats); setCache(`truongnganh_${maNganh}`, newStats);
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetchData();
  }, [maNganh]);

  const getRoleName = () => 'Trưởng ngành';
  const formatDate = () => today.toLocaleDateString('vi-VN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

  if (loading) return <div className="flex items-center justify-center h-64"><span className="material-symbols-outlined text-primary animate-spin text-4xl">sync</span></div>;

  return (
    <div className="space-y-5 md:space-y-6">
      <section className="flex flex-col md:flex-row justify-between items-start md:items-end gap-3">
        <div>
          <h1 className="text-[24px] md:text-[28px] font-bold text-primary">Xin chào, {getRoleName()} {user?.tenThanh ? `${user?.tenThanh} ` : ''}{user?.hoTen || '...'}</h1>
          <p className="text-body-md text-on-surface-variant mt-1">Ngành: <strong>{user?.tenNganh || maNganh}</strong> • Năm học 2025-2026</p>
        </div>
        <div className="text-caption text-on-surface-variant flex items-center gap-1 bg-surface-container-low px-3 py-1.5 rounded-full"><span className="material-symbols-outlined text-sm">calendar_today</span>{formatDate()}</div>
      </section>

      <section className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
        {[
          { icon: 'groups', label: 'Học sinh', value: stats.tongHS, path: '/quan-ly-hoc-sinh', color: 'text-primary', bg: 'bg-primary-container' },
          { icon: 'school', label: 'Lớp học', value: stats.tongLop, path: '/cai-dat', color: 'text-secondary', bg: 'bg-secondary-container' },
          { icon: 'manage_accounts', label: 'Giáo viên', value: stats.tongGV, path: '/quan-ly-nguoi-dung', color: 'text-tertiary', bg: 'bg-tertiary-container' },
          { icon: 'trending_up', label: 'Chuyên cần', value: `${stats.tyLeCC}%`, path: '/bao-cao', color: 'text-green-600', bg: 'bg-green-100' },
        ].map((c, i) => (
          <button key={i} onClick={() => navigate(c.path)} className="bg-surface rounded-xl p-4 shadow-sm border border-outline-variant flex flex-col justify-between hover:shadow-md transition-all active:scale-[0.98] text-left">
            <div className="flex justify-between items-start mb-2"><span className="text-body-md text-on-surface-variant">{c.label}</span><div className={`p-1.5 rounded-full ${c.bg}`}><span className={`material-symbols-outlined ${c.color} text-xl`}>{c.icon}</span></div></div>
            <div className={`text-[32px] font-bold ${c.color}`}>{c.value}</div>
            <span className="text-caption text-on-surface-variant/60 mt-1">Xem chi tiết →</span>
          </button>
        ))}
      </section>

      <section>
        <h2 className="text-section-title text-primary mb-3 font-bold flex items-center gap-2"><span className="material-symbols-outlined">bolt</span>Thao tác nhanh</h2>
        <div className="grid grid-cols-2 gap-2">
          {[
            { icon: 'group', label: 'Quản lý HS', path: '/quan-ly-hoc-sinh', color: 'bg-primary' },
            { icon: 'monitoring', label: 'Báo cáo', path: '/bao-cao', color: 'bg-secondary' },
          ].map((a, i) => (
            <button key={i} onClick={() => navigate(a.path)} className={`${a.color} text-on-primary rounded-xl p-4 flex flex-col items-center justify-center gap-2 hover:opacity-90 transition-opacity active:scale-95`}>
              <span className="material-symbols-outlined text-3xl">{a.icon}</span><span className="text-body-lg font-semibold">{a.label}</span>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TruongNganhDashboard;